import { useLocation } from "react-router-dom";
import Logo from "./Logo";
import { anchorScroll } from "./scroll";

const LINKS = [
  { label: "Services", href: "#services" },
  { label: "Loan Review", href: "#loan-review" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
  { label: "Privacy Policy", href: "/privacy-policy/" },
  { label: "Credit Guide", href: "/credit-guide/" },
];

const Footer = () => {
  const { pathname } = useLocation();
  return (
    <footer className="border-t border-ink/10 bg-ivory pb-10 pt-16 text-ink">
      <div className="mx-auto max-w-[88rem] px-6 lg:px-12">
        <div className="flex flex-col justify-between gap-10 md:flex-row md:items-center">
          <Logo />
          <nav className="flex flex-wrap gap-8" data-testid="footer-nav">
            {LINKS.map((l) => {
              const isAnchor = l.href.startsWith("#");
              const href = isAnchor && pathname !== "/" ? `/${l.href}` : l.href;
              return (
                <a
                  key={l.label}
                  href={href}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  onClick={isAnchor ? (e) => anchorScroll(e, l.href.slice(1)) : undefined}
                  className="link-sweep font-mono text-[11px] uppercase tracking-[0.22em] text-ink/60 transition-colors hover:text-eucalyptus"
                >
                  {l.label}
                </a>
              );
            })}
          </nav>
        </div>

        <div className="mt-12 border-t border-ink/10 pt-8">
          <p
            data-testid="footer-compliance"
            className="font-mono text-[10px] leading-relaxed tracking-[0.08em] text-ink/45"
          >
            Toro Finance Group Credit Representative 554728 is authorised under
            Australian Credit Licence Number: 389328 | ABN 59 673 013 646
          </p>
          <p
            data-testid="footer-memberships"
            className="mt-3 font-mono text-[10px] tracking-[0.08em] text-ink/45"
          >
            Member — Finance Brokers Association of Australia (FBAA) · Aggregated
            through Connective
          </p>
          <p className="mt-3 font-mono text-[10px] tracking-[0.08em] text-ink/35">
            © {new Date().getFullYear()} Toro Finance Group. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
